import React, { useState } from 'react';
import { Form, Input, Button, Checkbox, Radio, Upload, message, Result } from "antd";
import './login.css'
import api from '../../api';

const Login = (props) => {
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")

    const handleAdminLogin = () => {
        let data = {
            admin_username: username,
            admin_password: password
        }
        console.log("LOGIN DATA ", data)
        api.auth.login(data).then(result => {
            console.log("LOGIN RESULT ", result);
            if (result.status === 1) {
                message.success(result.message);
                setTimeout(() => {
                    props.loggedIn(true);
                }, 2000);
                localStorage.setItem("token", JSON.stringify(result.token));
            } else {
                message.error(result.message);
            }
        }).catch(error => {
            console.log(error)
        })
    }

    return (
        <div className="d-flex justify-content-center">
            <Form
                className=""
                style={{
                    marginTop: "10%",
                    //  marginLeft: "30%"
                }}
                // labelCol={{ span: 8 }}
                // wrapperCol={{ span: 20 }}
                size={"default"}
                labelAlign={"left"}>
                <Form.Item >
                    <h1 className="d-flex justify-content-center title-style">AlgoAnalytics</h1>
                </Form.Item>
                <Form.Item label="Username" >
                    <Input onChange={(e) => setUsername(e.target.value)} />
                </Form.Item>
                <Form.Item label="Password">
                    <Input.Password onChange={(e) => setPassword(e.target.value)} />
                    {/* <Form.Item>
                        <div className="d-flex justify-content-end" style={{ color: '#1890ff' }}>
                            Change Password?
                        </div>
                    </Form.Item> */}
                </Form.Item>

                <Form.Item >
                    <div className="d-flex justify-content-center btn-style">
                        <Button style={{
                            // marginLeft: "40%", 
                            width: "50%"
                        }}
                            className=""
                            type="primary"
                            onClick={() => {
                                // username === "admin" && password === "12345" ?
                                //     props.loggedIn(true) : window.alert("Wrong credentials");

                                handleAdminLogin()
                            }}>
                            Login
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </div>);
}

export default Login;